import React, { useState,useEffect }  from 'react';
import {Link} from 'react-router-dom'
import axios from 'axios';

import { BASE_URL } from '../Config/Base';
import { ToastContainer, toast } from 'react-toastify';
import { Oval } from  'react-loader-spinner'
import _ from 'lodash'


const pageSize =5;
const pageSizeB =5;
const TecAboutMain = () => {

  useEffect(()=>{  
    
  

    setTimeout(() => {
            
  
      getroleAction() 
    
        
       }, 2000);
   
  }, [])
  const[pop,setpop] = useState(false);
  let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));

  const [sectionAbout, setSectionAbout] = useState([])
  const [EditSectionAbout, setEditSectionAbout] =useState([])
  const [paginatedPosts, setpaginatedPosts] = useState();
  const [currentPage, setcurrentPage] = useState(1);
  const [paginatedPostsB, setpaginatedPostsB] = useState();
  const [currentPageB, setcurrentPageB] = useState(1);

  ///getTecAbout


  function getTecAbout()
  {

 

  fetch(`${BASE_URL}/Tec/GettecAbout`, {

    method: 'GET',

    headers: {

      "Content-type": "application/json",

      "Accept": "application/json",



      "Access-Control-Allow-Headers": "Access-Control-Request-Headers "

    },

    //body:JSON.stringify(data)

  }).then(response => response.json())

    .then(data => {
      console.log("DatasectionA", data);
      setSectionAbout(data)
      setpaginatedPostsB(_(data).slice(0).take(pageSizeB).value());
        }
    );



      }
      const pageCountB = sectionAbout? Math.ceil(sectionAbout.length/pageSizeB) :0;
      // if (pageCountB === 1)
      // return null;
      
      const pagesB = _.range(1, pageCountB+1)
      
      const paginationB =(pageNoB)=>{
      setcurrentPageB(pageNoB);
      const startIndex = (pageNoB - 1) * pageSizeB;
      const paginatedPostB = _(sectionAbout).slice(startIndex).take(pageSizeB).value();
      setpaginatedPostsB(paginatedPostB)
      }
      const onNextB = () => {


        paginationB(currentPageB + 1);
      };
      
      const onPreviousB = () => {
        paginationB(currentPageB - 1);
      };
      ///submitsection

   const [fileAbout, setFileAbout] = useState();
   const [fileAboutImg, setFileAboutImg] = useState();
   // console.log(file)
   
   const handleFileChangeAbout = (e) => {
    
       setFileAbout(e.target.files[0]);
       setFileAboutImg(URL.createObjectURL(e.target.files[0]));
   };
 
   function submitsectionAbout(){
    var UserId= localStorage.getItem('UserId')

    var Heading = document.getElementById("heading").value;
     var textAbout = document.getElementById("text").value;



     
     if(!Heading){

      document.getElementById("AddErrA").innerHTML="Heading Required"

    }
    else if(Heading){

      document.getElementById("AddErrA").innerHTML=" "

    }
     if(!textAbout){

       document.getElementById("AddErrB").innerHTML="Content Required"

     }
     else if(textAbout){

       document.getElementById("AddErrB").innerHTML=" "

     }
     
     if(!fileAbout){

       document.getElementById("AddErrC").innerHTML="image Required"

     }
     else if(fileAbout){

       document.getElementById("AddErrC").innerHTML=" "

     }

     if(Heading && textAbout &&fileAbout){



    const body =
     {
       Heading:Heading,
       Text:textAbout, 
       Image:fileAbout,
       ActiveStatus:0,
       DeleteStatus:0,
       CreatedBy:UserId
       

        
     
     }
     console.log('body',body);

   
     axios({
            method:"POST",
            url :`${BASE_URL}/Tec/AddtecAbout`,
            data:body, 
            headers: {
                 "Content-Type": "multipart/form-data",
                 'Authorization':bearer 
             }     
         }) 
 
        .then((response) =>{
        console.log(response.data);
   
   
        if(response.data.status === "Success"){
          
          setSuccessToast(true)
           
          
             setTimeout(() => {
              setSuccessToast(false)
              getTecAbout()

              closeAboutAddForm()
             }, 2000);
           }

   
     })
     .catch(error => {
       console.log(error);
     //  alert("failed !")
     alert("failed to Add") 

     })
       
   }

   }


   
     ////Get Particular Data PostMethod



      

        
       
     function editSectionAbout(Id){

      SelectParticular(Id)
      document.getElementById("AboutEditPop").style.display = "block";
     }
      function SelectParticular(Id){
    const body =
     {
       
      id:Id
     }
     console.log('body',body);

   
     axios({
            method:"POST",
            url :`${BASE_URL}/Tec/EdittecAbout`,
            data:body, 
            headers: {
                 "Content-type": "application/json",
                 'Authorization':bearer 
             }     
         }) 
         
    
         .then((response) =>{
           console.log(JSON.stringify(response.data));
      
       
           setEditSectionAbout(response.data)

          
      
        })
        .catch(error => {
          console.log(error);
          
        })

     }



     function updateSectionAbout(Id){

      var UserId= localStorage.getItem('UserId')
  
       var TextAbout = document.getElementById("textA").value;
       var ImagefileAbout = document.getElementById("tecimage").src;

       var Heading = document.getElementById("Eheading").value;
   



     
     if(!Heading){

      document.getElementById("ErrA").innerHTML="Heading Required"

    }
    else if(Heading){

      document.getElementById("ErrA").innerHTML=" "

    }

       if(!TextAbout){

         document.getElementById("ErrB").innerHTML="Content Required"

       }
       else if(TextAbout){

         document.getElementById("ErrB").innerHTML=" "

       }
       
      
      
      
       if(Heading && TextAbout){


       



    const body =
     {
       Id:Id,
       Heading:Heading,
       Text:TextAbout, 
       Image:fileAbout,
       OldImage:ImagefileAbout,
       EditedBy:UserId

        
     
     }
     console.log('body',body);

   
     axios({
            method:"POST",
            url :`${BASE_URL}/Tec/UpdatetecAbout`,
            data:body, 
            headers: {
                 "Content-Type": "multipart/form-data",
                 'Authorization':bearer 
             }     
         }) 
 
        .then((response) =>{
        console.log(response.data);
   
   
        if(response.data.status === "Success"){
          closeAboutEditForm()
            setUpdateToast(true)
           
             setTimeout(() => {
              setcurrentPageB(1)
              getTecAbout()
              setUpdateToast(false)
             
             }, 2000);
           }
   
     })
     .catch(error => {
       console.log(error);
     //  alert("failed !")
     alert("failed to Update")   
     })
       
    
   }

     }
   

   ///DeleteSectionA

   function DeleteSectionAbout(Id){

 
   

    const body =
     {
       Id:Id,
    
      

        
     
     }
     console.log('body',body);

   
     axios({
            method:"POST",
            url :`${BASE_URL}/Tec/DeletetecAbout`,
            data:body, 
            headers: {
               "Content-type": "application/json",
                 'Authorization':bearer 
             }     
         }) 
 
        .then((response) =>{
        console.log(response.data);
   
   
        closeForm()
        
           setDeleteErrToast(true)
           
             setTimeout(() => {
             
              getTecAbout()
              setcurrentPageB(1)
              setDeleteErrToast(false)
             }, 2000);
            
             
           
   
     })
     .catch(error => {
       console.log(error);
     //  alert("failed !")
     alert("failed to Update")   
     })
       
    

   

   }





   //closeAddForm

   function closeAboutAddForm(){


    setFileAbout();
    setFileAboutImg();
 
    document.getElementById("AddErrA").innerHTML=" "
    document.getElementById("AddErrB").innerHTML=" "
    document.getElementById("AddErrC").innerHTML=" "
    document.getElementById("tecform").reset();
           
    document.getElementById("AboutAddPop").style.display = "none";
   
   
  }

 
  
   //closeEditForm

  function closeAboutEditForm(){

   setFileAbout();
   setFileAboutImg();
   document.getElementById("ErrA").innerHTML=" "
   document.getElementById("ErrB").innerHTML=" "
   document.getElementById("teceditform").reset();

   
   document.getElementById("AboutEditPop").style.display = "none";
  }


  //OpenAddForm

  function openAboutForm(){

    document.getElementById("AboutAddPop").style.display = "block";

  }


  const [sectionAboutMain, setSectionAboutMain] = useState([])
  const [EditSectionAboutMain, setEditSectionAboutMain] =useState([])


  ///getTecAbout


  function getTecAboutMain()
  {

  

  fetch(`${BASE_URL}/Tec/GettecAboutMain`, {

    method: 'GET',

    headers: {

      "Content-type": "application/json",

      "Accept": "application/json",

  

      "Access-Control-Allow-Headers": "Access-Control-Request-Headers "

    },

    //body:JSON.stringify(data)

  }).then(response => response.json())

    .then(data => {
      console.log("DatasectionA", data);
      setSectionAboutMain(data)
      setpaginatedPosts(_(data).slice(0).take(pageSize).value());
        }
    );



      }
      const pageCount = sectionAboutMain? Math.ceil(sectionAboutMain.length/pageSize) :0;
      // if (pageCount === 1)
      // return null;
      
      const pages = _.range(1, pageCount+1)
      
      const pagination =(pageNo)=>{
      setcurrentPage(pageNo);
      const startIndex = (pageNo - 1) * pageSize;
      const paginatedPost = _(sectionAboutMain).slice(startIndex).take(pageSize).value();
      setpaginatedPosts(paginatedPost)
      }
      const onNext = () => {


        pagination(currentPage + 1);
      };
    
      const onPrevious = () => {
        pagination(currentPage - 1);
      };



      
      ///submitsection

 
   function submitsectionAboutMain(){

    var UserId= localStorage.getItem('UserId')
   
     var textAbout = document.getElementById("Maintext").value;



     
     
     if(!textAbout){

       document.getElementById("MainAddErrA").innerHTML="Content Required"

     }
     else if(textAbout){

       document.getElementById("MainAddErrA").innerHTML=" "

     }
     

     if(textAbout){



    const body =
     {
       
       Text:textAbout, 
       
       ActiveStatus:0,
       DeleteStatus:0,
       CreatedBy:UserId
      

        
     
     }
     console.log('body',body);

   
     axios({
            method:"POST",
            url :`${BASE_URL}/Tec/AddtecAboutMain`,
            data:body, 
            headers: {
                 "Content-Type": "multipart/form-data",
                 'Authorization':bearer 
             }     
         }) 
 
        .then((response) =>{
        console.log(response.data);
   
   
        if(response.data.status === "Success"){
          
        
            setSuccessToast(true)
          
             setTimeout(() => {
              setSuccessToast(false)
              getTecAboutMain()

              closeAboutMainAddForm()
             }, 2000);
           }

   
     })
     .catch(error => {
       console.log(error);
     //  alert("failed !")
     alert("failed to Add") 

     })
       
   }

   }


   
     ////Get Particular Data PostMethod

     function editSectionAboutMain(Id){
      MainSelectParticular(Id)

      document.getElementById("AboutMainEditPop").style.display = "block";
     }
   function  MainSelectParticular(Id){
    const body =
     {
       
      id:Id
     }
     console.log('body',body);

   
     axios({
            method:"POST",
            url :`${BASE_URL}/Tec/EdittecAboutMain`,
            data:body, 
            headers: {
                 "Content-type": "application/json",
                 'Authorization':bearer 
             }     
         }) 
         
    
         .then((response) =>{
           console.log(JSON.stringify(response.data));
      
       
           setEditSectionAboutMain(response.data)

          
      
        })
        .catch(error => {
          console.log(error);
          
        })

     }



     function updateSectionAboutMain(Id){


      var UserId= localStorage.getItem('UserId')
       var TextAbout = document.getElementById("MaintextA").value;
      
   



     
   

       if(!TextAbout){

         document.getElementById("MainErrA").innerHTML="Content Required"

       }
       else if(TextAbout){

         document.getElementById("MainErrA").innerHTML=" "

       }
       
      
      
      
       if(TextAbout){


       



    const body =
     {
       Id:Id,
      
       Text:TextAbout, 
      
       EditedBy:UserId
       

        
     
     }
     console.log('body',body);

   
     axios({
            method:"POST",
            url :`${BASE_URL}/Tec/UpdatetecAboutMain`,
            data:body, 
            headers: {
                 "Content-Type": "multipart/form-data",
                 'Authorization':bearer 
             }     
         }) 
 
        .then((response) =>{
        console.log(response.data);
   
   
        if(response.data.status === "Success"){


          closeAboutMainEditForm()
          setUpdateToast(true)
           
             setTimeout(() => {
              setcurrentPage(1)
              getTecAboutMain()
              setUpdateToast(false)
              
             }, 2000);
           }
   
     })
     .catch(error => {
       console.log(error);
     //  alert("failed !")
     alert("failed to Update")   
     })
       
    
   }

     }
   

   ///DeleteSectionA

   function DeleteSectionAboutMain(Id){

 
    

    const body =
     {
       Id:Id,
    
      

        
     
     }
     console.log('body',body);

   
     axios({
            method:"POST",
            url :`${BASE_URL}/Tec/DeletetecAboutMain`,
            data:body, 
            headers: {
               "Content-type": "application/json",
                 'Authorization':bearer 
             }     
         }) 
 
        .then((response) =>{
        console.log(response.data);
   
   
        MaincloseForm()
        
        setDeleteErrToast(true)
           
             setTimeout(() => {
             
              getTecAboutMain()
              setDeleteErrToast(false)

              setcurrentPage(1)
             }, 2000);
            
             
           
   
     })
     .catch(error => {
       console.log(error);
     //  alert("failed !")
     alert("failed!")   
     })
       
    

   

   }





   //closeAddForm

   function closeAboutMainAddForm(){


   
   
 
    document.getElementById("MainAddErrA").innerHTML=" "
  
    document.getElementById("Maintecform").reset();
           
    document.getElementById("AboutMainAddPop").style.display = "none";
   
   
  }

 
  
   //closeEditForm

  function closeAboutMainEditForm(){

  
   document.getElementById("MainErrA").innerHTML=" "
 
   document.getElementById("Mainteceditform").reset();

   
   document.getElementById("AboutMainEditPop").style.display = "none";
  }


  //OpenAddForm

  function openAboutMainForm(){

    document.getElementById("AboutMainAddPop").style.display = "block";

  }







  function OpenTecGridMain(){


  getTecAboutMain()
  document.getElementById("TecSelectMain").style.display="none"
  document.getElementById("TecGridMainA").style.display="block"
  document.getElementById("PopAAdd").style.display="none"
  document.getElementById("PopATable").style.display="none"
  setpop(true);
  
  setTimeout(()=>{
  setpop(false);
  getAssignedActionMain()

},1000)
  
  }


  function OpenAboutContent(){
    
    getTecAbout()
    document.getElementById("TecGridMainB").style.display="block"
    document.getElementById("TecSelectMain").style.display="none"
    

    document.getElementById("PopBAdd").style.display="none"
      document.getElementById("PopBTable").style.display="none"
      setpop(true);
     
      setTimeout(()=>{
      setpop(false);
      getAssignedAction()
      
      
    },1000)
  }


  function BackMain(){

    document.getElementById("TecGridMainA").style.display="none"
    document.getElementById("TecGridMainB").style.display="none"
    document.getElementById("TecSelectMain").style.display="block"

  }




  function getroleAction(){

   

    let LoginRole =  localStorage.getItem("Role");
 
    console.log('checkrole',LoginRole);
    const body =
    {
      
     role:LoginRole
    }
    console.log('body',body);

  
    axios({
           method:"POST",
           url :`${BASE_URL}/Tec/GetTecRoleAction`,
           data:body, 
           headers: {
                "Content-type": "application/json",
                "Authorization": bearer,
            }     
        }) 
        
   
        .then((response) =>{
          console.log(response.data);
     
       
       
                
          localStorage.setItem("LoginAction",JSON.stringify(response.data))
          localStorage.getItem("LoginAction");
       })
       .catch(error => {
         console.log(error);
  })
}

  const[editicon,setediticon] = useState(false);
  const[delicon,setdelicon] = useState(false);
  const[denied,setdenied] = useState(false);    
  function getAssignedActionMain(){



  ////Admin
    let LoginRole =  localStorage.getItem("RoleId");
  

    let CheckSAdmin = LoginRole.includes("00")
    let CheckAdmin =LoginRole.includes("01")


  /////////////Teammate
    let LoginAction =  localStorage.getItem("LoginAction");
    let TecRoleAction =  JSON.parse(LoginAction);
    let roleAction = TecRoleAction.map((e)=>e.roleAction);
    console.log(roleAction);
    
    let roles = roleAction.toString();
    let roleResult = roles.includes('Add')
    console.log(roleResult)
    
    let roleResultA = roles.includes('View')
    console.log(roleResultA)
    
    let roleResultB = roles.includes('Edit')
    console.log(roleResultB)
    
    let roleResultC = roles.includes('Delete')
    console.log(roleResultC)


   

    if(roleResult==true && CheckSAdmin==false && CheckAdmin==false){

      document.getElementById('PopAAdd').style.display ="block";
    }
    else if(CheckSAdmin==true || CheckAdmin==true){
      document.getElementById('PopAAdd').style.display ="block";
    }
    else{
      document.getElementById('PopAAdd').style.display ="none";

    }
    if(roleResultA==true  && CheckSAdmin==false && CheckAdmin==false){

      document.getElementById('PopATable').style.display ="block";
    }
    else if(CheckSAdmin==true || CheckAdmin==true){
      document.getElementById('PopATable').style.display ="block";
    }
    else{
      document.getElementById('PopATable').style.display ="none";

    }
    if(roleResultB==true  && CheckSAdmin==false && CheckAdmin==false){
  
      setediticon(true)
    }
    else if(CheckSAdmin==true || CheckAdmin==true){
      setediticon(true)
    }
    else{
      setediticon(false)

    }
    if(roleResultC==true  && CheckSAdmin==false && CheckAdmin==false){

      setdelicon(true)
    }
    else if(CheckSAdmin==true || CheckAdmin==true){
      setdelicon(true)
    }
    else{
      setdelicon(false)

    }

    if(roleResultB==false  && roleResultC==false && CheckSAdmin==false && CheckAdmin==false){

      setdenied(true)
    }
    else{

      setdenied(false)
    }
    if( roleResultA==false && CheckSAdmin==false && CheckAdmin==false){
      document.getElementById("TecActionDenied").innerHTML="View Table is not Assigned"
       }
  }
  function getAssignedAction(){



    ////Admin
      let LoginRole =  localStorage.getItem("RoleId");
    
  
      let CheckSAdmin = LoginRole.includes("00")
      let CheckAdmin =LoginRole.includes("01")
  
  
     /////////////Teammate
      let LoginAction =  localStorage.getItem("LoginAction");
      let TecRoleAction =  JSON.parse(LoginAction);
      let roleAction = TecRoleAction.map((e)=>e.roleAction);
      console.log(roleAction);
      
      let roles = roleAction.toString();
      let roleResult = roles.includes('Add')
      console.log(roleResult)
      
      let roleResultA = roles.includes('View')
      console.log(roleResultA)
      
      let roleResultB = roles.includes('Edit')
      console.log(roleResultB)
      
      let roleResultC = roles.includes('Delete')
      console.log(roleResultC)
  
  
     
  
      if(roleResult==true && CheckSAdmin==false && CheckAdmin==false){
  
        document.getElementById('PopBAdd').style.display ="block";
      }
      else if(CheckSAdmin==true || CheckAdmin==true){
        document.getElementById('PopBAdd').style.display ="block";
      }
      else{
        document.getElementById('PopBAdd').style.display ="none";
  
      }
      if(roleResultA==true  && CheckSAdmin==false && CheckAdmin==false){
  
        document.getElementById('PopBTable').style.display ="block";
      }
      else if(CheckSAdmin==true || CheckAdmin==true){
        document.getElementById('PopBTable').style.display ="block";
      }
      else{
        document.getElementById('PopBTable').style.display ="none";
  
      }
      if(roleResultB==true  && CheckSAdmin==false && CheckAdmin==false){
  
        setediticon(true)
      }
      else if(CheckSAdmin==true || CheckAdmin==true){
        setediticon(true)
      }
      else{
        setediticon(false)
  
      }
      if(roleResultC==true  && CheckSAdmin==false && CheckAdmin==false){
  
        setdelicon(true)
      }
      else if(CheckSAdmin==true || CheckAdmin==true){
        setdelicon(true)
      }
      else{
        setdelicon(false)
  
      }

      if(roleResultB==false  && roleResultC==false && CheckSAdmin==false && CheckAdmin==false){

        setdenied(true)
      }
      else{
  
        setdenied(false)
      }
      if( roleResultA==false && CheckSAdmin==false && CheckAdmin==false){
        document.getElementById("TecActionDeniedA").innerHTML="View Table is not Assigned"
         }
    }

    function MainConfirmDelete(Id){

      MainSelectParticular(Id)
      setTimeout(() => {
        document.getElementById("MainmodaldeleteForm").style.display = "block";
      },1000);
    
    }
    function ConfirmDelete(Id){

      SelectParticular(Id)
      setTimeout(() => {
        document.getElementById("modaldeleteForm").style.display = "block";
      },1000);
    
    }

    function MaincloseForm(){

      document.getElementById("MainmodaldeleteForm").style.display ="None"
    
    }
    function closeForm(){

      document.getElementById("modaldeleteForm").style.display ="None"
    
    }



    const[SuccessToast,setSuccessToast] = useState(false);  
const[UpdateToast,setUpdateToast] = useState(false);  
const[DeleteToast,setDeleteErrToast] = useState(false);
  return (
    <>


     {/* Toast */}
    {SuccessToast? <div className='tec-toastpop-fade'>
      <div className="modal-dialog" role="document">
      <div id='tecToastcontainer' style={{left:"20%"}}>
    <div id="Tec-success-box">
    <div className="Tec-Toastdot"></div>
    <div className="Tec-Toastdot Tec-Toasttwo"></div>
    <div className="Tec-Toastface">
      <div className="Tec-Toasteye"></div>
      <div className="Tec-Toasteye Tec-Toastright"></div>
      <div className="Tec-Toastmouth Tec-Toasthappy"></div>
    </div>
    <div className="Tec-Toastshadow scale"></div>
    <div className="Tec-Toastmessage"><h1 class="Tec-Toastalert">Success!</h1><p>Added Successfully</p></div>
   
  </div></div></div></div>:null}
   {/* Toast */}
  {DeleteToast? <div className='tec-toastpop-fade'>
      <div className="modal-dialog" role="document">
      <div id='tecToastcontainer' style={{left:"20%"}}>
    <div id="Tec-success-box">
    <div className="Tec-Toastdot"></div>
    <div className="Tec-Toastdot Tec-Toasttwo"></div>
    <div className="Tec-Toastface">
      <div className="Tec-Toasteye"></div>
      <div className="Tec-Toasteye Tec-Toastright"></div>
      <div className="Tec-Toastmouth Tec-Toasthappy"></div>
    </div>
    <div className="Tec-Toastshadow scale"></div>
    <div className="Tec-Toastmessage"><h1 class="Tec-Toastalert">Success!</h1><p>Deleted Successfully</p></div>
   
  </div></div></div></div>:null} 


   {/* Toast */}
   {UpdateToast? <div className='tec-toastpop-fade'>
      <div className="modal-dialog" role="document">
      <div id='tecToastcontainer' style={{left:"20%"}}>
    <div id="Tec-success-box">
    <div className="Tec-Toastdot"></div>
    <div className="Tec-Toastdot Tec-Toasttwo"></div>
    <div className="Tec-Toastface">
      <div className="Tec-Toasteye"></div>
      <div className="Tec-Toasteye Tec-Toastright"></div>
      <div className="Tec-Toastmouth Tec-Toasthappy"></div>
    </div>
    <div className="Tec-Toastshadow scale"></div>
    <div className="Tec-Toastmessage"><h1 class="Tec-Toastalert">Success!</h1><p>Updated Successfully!</p></div>
   
  </div></div></div></div>:null}


   
    <div className='tec-addmain' id="TecSelectMain">
      
    
        
  <div className="tec-addgrid-layout">
<div className="tec-addmain-top">
 
  <p><span id="tectopspan"><span id="TecTitleMain">ABOUT </span></span> 
  <div className='tec-addmain-back'>
  <Link to="/TecCompany"><i class="fa fa-angle-double-left" aria-hidden="true" id="tecbackicon"></i></Link>
  </div></p> 

  {/* <hr></hr> */}
  </div>  </div>
  <div class="tec-hero"> 
  <div class="techero__title"></div>
  <div class="teccube"></div>
  <div class="teccube"></div>
  <div class="teccube"></div>
  <div class="teccube"></div>
  <div class="teccube"></div>
  <div class="teccube"></div>
</div>
  <div className='tecTwoList'>

  <div class="tecTwoList_responsive">
  
  <div id="TecSelectB" >

<div id="items-body-content" onClick={OpenTecGridMain}>
 <span id="TecSelectBtn">About Main</span>
 <i class="fa fa-angle-right"></i>
</div>
<div id="items-body-content" onClick={OpenAboutContent}>
 <span>About Content </span>
 <i class="fa fa-angle-right"></i>
</div>
</div>
</div>  </div>

  </div>
        
     
<div id="TecGridMainA" className='tec-addmain'>

<div className="tec-addgrid-layout">
<div className="tec-addmain-top">
 
  <p><span id="tectopspan"><span id="TecTitleMain">ABOUT MAIN </span></span> <div className='tec-addmain-back'>
  <Link onClick={BackMain}><i class="fa fa-angle-double-left" aria-hidden="true" id="tecbackicon"></i></Link>
  </div></p> 
{/* 
  <hr></hr> */}
  </div>
  
  </div>
  <div className='tec-addmain-add' id="PopAAdd">
      <button className='add-user' onClick={openAboutMainForm}>  Add About Main</button>
 </div>
 


  {/* EditAboutMain */}
  <div className='tech-pop-fade' id="AboutMainEditPop">
{EditSectionAboutMain.map((e)=>{
   return<div className="modal-dialog" role="document">
    <div className="modal-content" style={{marginTop:"220px"}}>
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">EDIT CONTENT</h4>
        <button type="button" className="close" onClick={closeAboutMainEditForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form  id="Mainteceditform" onSubmit={()=>updateSectionAboutMain(e.id)}>
      <div className="modal-body mx-3">


        
    
        <div className="md-form mb-5">
        <label id="sectionlable">Content</label> 
          <textarea type="text" id="MaintextA"  defaultValue={e.content}/>
          <span id="MainErrA" className='error'></span>
        </div> 
        
       
      </div>
      <div className="modal-footer d-flex justify-content-center">
        <button className='tec-adduser-button' type="submit">Update</button>
      </div>
      </form>
    </div>
  </div>})}

</div>

{/* AddAboutMain */}
<div className='tech-pop-fade' id="AboutMainAddPop">

  <div className="modal-dialog" role="document">
    <div className="modal-content" style={{marginTop:"220px"}}>
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">ADD CONTENT</h4>
        <button type="button" className="close" onClick={closeAboutMainAddForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form  id="Maintecform" onSubmit={submitsectionAboutMain} >
      <div className="modal-body mx-3">

     
        <div className="md-form mb-5">
           
        <label id="sectionlable">Content</label> 
          <textarea type="text" id="Maintext"/>
          <span id="MainAddErrA" className='error'></span>
        </div> 
        
      </div>
      <div className="modal-footer d-flex justify-content-center">
        <button className='tec-adduser-button' type="submit">Add</button>
      </div>
      </form>
    </div>
  </div>

</div> 

{/* DeletePopup */}

{EditSectionAboutMain.map((e)=>{ 
   return<div className="tec-pop-fade" id="MainmodaldeleteForm" tabindex="-1" role="dialog">
     <div className="modal-dialog" role="document">
      <div className="modal-content" style={{marginTop:"240px"}}>
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">! Warning</h4>
        <button type="button" className="close" onClick={MaincloseForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

    <form id='form'>

     <div className="modal-body mx-3">

        <div className="md-form mb-4">
            <div className='text-center'>
          <h5 style={{marginTop:"25px"}}>Are you sure want to Delete <span>{e.userName}</span> ?</h5>
          </div>
        </div>

      </div>

       <div className="modal-footer d-flex justify-content-center">
       <button className="tec-adduser-button" onClick={()=>DeleteSectionAboutMain(e.id)} type='submit'>Delete</button>
        <button className="tec-adduser-button" onClick={MaincloseForm} type='submit'>Cancel</button>
       </div>

       </form>
      
     </div>
    </div>
</div>})}



    <div className='tec-sectionMain' id="PopATable">
    {
 sectionAboutMain.length==0  ? (<div id="TecApiFail">" No Data Found "</div>):(
<div>
<div className='tectable'>

  <div class="tec-table_responsive">
 
<table>
  <thead>
    <tr>
       
      <th>Content</th>
      <th>Action</th>
    </tr>
  </thead>
  <tbody>
    {paginatedPosts.map((e)=>{
    
  
    return<tr>
   
    
    <td><div style={{inlineSize:"290px",overflowWrap:"break-word",wordWrap:"break-word"}}>{e.content}</div></td>
    <td style={{whiteSpace:"nowrap"}}>
    {editicon?<span><i class="fa fa-pencil" aria-hidden="true" onClick={()=>editSectionAboutMain(e.id)} id="tecEditicon"></i></span> :null}&nbsp;&nbsp;
      {delicon?<span><i class="fa fa-trash" aria-hidden="true" onClick={()=>MainConfirmDelete(e.id)} id="tecDelicon"></i></span>:null}
      {denied?<span className='error'>Denied</span>:null}
    
    </td>
    </tr>
 } )}
  </tbody>
</table>

</div>
</div>

<br></br>
{pageCount==1?null:<nav  id="tecpagenav">
    <ul className='pagination'>
      {/* {
        pages.map((page)=>(
          <li className={
            page === currentPage ? "page-item active" : "page-item"
          }>
            
            
            
            <p className='tecpage-link'onClick={()=>pagination(page)}>
            {page}
            </p>
            </li>
        ))
      } */}
       
       {currentPage >1?<li className="page-item">
              <a class="tecpage-link" onClick={onPrevious} aria-label="Next">
                <span aria-hidden="true">&laquo;</span>
                <span class="sr-only">Previous</span>
              </a>
            </li>:null}
            &nbsp; &nbsp;
            <span style={{marginTop:"6px"}}>
         Page {currentPage} Of {pageCount} 
         
            </span>   &nbsp; &nbsp;
        {currentPage<pageCount?<li className="page-item">
              <a class="tecpage-link" onClick={onNext} aria-label="Next">
                <span aria-hidden="true">&raquo;</span>
                <span class="sr-only">Next</span>
              </a>
            </li>:null}

    </ul>
  </nav>}
</div>
)}
 



   

    </div>

  

    {pop? <div id="Loader">
<Oval
  height={40}
  width={50}
  id="Loader"
  color="black"
  wrapperStyle={{}}
  wrapperClass=""
  visible={true}
  ariaLabel='oval-loading'
  secondaryColor="gray"
  strokeWidth={2}
  strokeWidthSecondary={2}

/>
     </div>
 :null}

<div id="TecDenied">
   <span id="TecActionDenied"></span>

   </div>

    </div>

    <div id="TecGridMainB" className='tec-addmain'>
   
    <div className="tec-addgrid-layout">
<div className="tec-addmain-top">
 
  <p><span id="tectopspan"><span id="TecTitleMain">ABOUT  </span></span> <div className='tec-addmain-back'>
  <Link onClick={BackMain}><i class="fa fa-angle-double-left" aria-hidden="true" id="tecbackicon"></i></Link>
  </div></p> 
{/* 
  <hr></hr> */}
  </div>
  
  </div>
  <div className='tec-addmain-add' id="PopBAdd">
      <button className='add-user' onClick={openAboutForm}>  Add About</button>
 </div>
 
  <div>

  {/* EditAbout */}
  <div className='tech-pop-fade' id="AboutEditPop">
{EditSectionAbout.map((e)=>{
   return<div className="modal-dialog" role="document">
    <div className="modal-content" style={{marginTop:"90px"}}>
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">EDIT SECTION</h4>
        <button type="button" className="close" onClick={closeAboutEditForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form  id="teceditform" onSubmit={()=>updateSectionAbout(e.id)}>
      <div className="modal-body mx-3">
      <div className="text-center md-form mb-5" style={{marginTop:"-25px"}}>
        {/* <label id="sectionlable">Image</label> */}
    
         <input type="file" onChange={handleFileChangeAbout} style={{opacity:"0",position:"relative",top:"50px",left:"200px",zIndex:"1"}} />
         {!fileAboutImg?<img id="tecimage" src={e.image}  /> :<img id="tecimage" src={fileAboutImg}  /> } 
         <span id="editimg-Tec"><i class="fa fa-pencil" aria-hidden="true" ></i></span>
        </div>

        
      <div className="md-form mb-5">
           
           <label id="sectionlable">Heading</label> 
             <input type="text" id="Eheading" defaultValue={e.heading}/>
             <span id="ErrA" className='error'></span>
           </div> 
        <div className="md-form mb-5">
        <label id="sectionlable">Content</label> 
          <textarea type="text" id="textA"  defaultValue={e.content}/>
          <span id="ErrB" className='error'></span>
        </div> 
        
        
      </div>
      <div className="modal-footer d-flex justify-content-center">
        <button className='tec-adduser-button' type="submit">Update</button>
      </div>
      </form>
    </div>
  </div>})}

</div>

{/* AddAbout */}
<div className='tech-pop-fade' id="AboutAddPop">

  <div className="modal-dialog" role="document">
    <div className="modal-content" style={{marginTop:"110px"}}>
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">ADD SECTION</h4>
        <button type="button" className="close" onClick={closeAboutAddForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form  id="tecform" onSubmit={submitsectionAbout} >
      <div className="modal-body mx-3">

      <div className="md-form mb-5">
           
           <label id="sectionlable">Heading</label> 
             <input type="text" id="heading"/>
             <span id="AddErrA" className='error'></span>
           </div> 
        <div className="md-form mb-5">
           
        <label id="sectionlable">Content</label> 
          <textarea type="text" id="text"/>
          <span id="AddErrB" className='error'></span>
        </div> 
        <div className="md-form mb-5">
          <label id="sectionlable">Image</label>  
 
         <input type="file" onChange={handleFileChangeAbout}/>
         
         <span id="AddErrC" className='error'></span>
        </div>
      </div>
      <div className="modal-footer d-flex justify-content-center">
        <button className='tec-adduser-button' type="submit">Add</button>
      </div>
      </form>
    </div>
  </div>

</div> 

 {/* DeletePopup */}

 {EditSectionAbout.map((e)=>{ 
   return<div className="tec-pop-fade" id="modaldeleteForm" tabindex="-1" role="dialog">
     <div className="modal-dialog" role="document">
      <div className="modal-content" style={{marginTop:"240px"}}>
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">! Warning</h4>
        <button type="button" className="close" onClick={closeForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

    <form id='form'>

     <div className="modal-body mx-3">

        <div className="md-form mb-4">
            <div className='text-center'>
          <h5 style={{marginTop:"25px"}}>Are you sure want to Delete <span>{e.userName}</span> ?</h5>
          </div>
        </div>

      </div>

       <div className="modal-footer d-flex justify-content-center">
       <button className="tec-adduser-button" onClick={()=>DeleteSectionAbout(e.id)} type='submit'>Delete</button>
        <button className="tec-adduser-button" onClick={closeForm} type='submit'>Cancel</button>
       </div>

       </form>
      
     </div>
    </div>
</div>})}


    <div className='tec-sectionMain' id="PopBTable">
    {
sectionAbout.length==0 ? (<div id="TecApiFail">" No Data Found "</div>):(   
<div>
<div className='tectable'>

  <div class="tec-table_responsive">
 
<table>
  <thead>
    <tr>
       <th>Heading</th>
      <th>Image</th>
      <th>Content</th>
      <th>Action</th>
    </tr>
  </thead>
  <tbody>
    {paginatedPostsB.map((e)=>{
    
  
    return<tr>
   
     <td>{e.heading}</td>
    <td><img src={e.image} alt="imgA" id="sectionImage"></img></td>
    <td><div style={{inlineSize:"290px",overflowWrap:"break-word",wordWrap:"break-word"}}>{e.content}</div></td>
    <td style={{whiteSpace:"nowrap"}}>
    {editicon?<span><i class="fa fa-pencil" aria-hidden="true" onClick={()=>editSectionAbout(e.id)} id="tecEditicon"></i></span>:null}  &nbsp;&nbsp;
      {delicon?<span><i class="fa fa-trash" aria-hidden="true" onClick={()=>ConfirmDelete(e.id)} id="tecDelicon"></i></span>:null} 
      {denied?<span className='error'>Denied</span>:null}
    </td>
    </tr>
 } )}
  </tbody>
</table>

</div>
</div>

<br></br>
{pageCountB==1?null:<nav  id="tecpagenav">
    <ul className='pagination'>
      {/* {
        pagesB.map((page)=>(
          <li className={
            page === currentPageB ? "page-item active" : "page-item"
          }>
            
            
            
            <p className='tecpage-link'onClick={()=>paginationB(page)}>
            {page}
            </p>
            </li>
        ))
      } */}
       
       {currentPageB >1?<li className="page-item">
              <a class="tecpage-link" onClick={onPreviousB} aria-label="Next">
                <span aria-hidden="true">&laquo;</span>
                <span class="sr-only">Previous</span>
              </a>
            </li>:null}
            &nbsp; &nbsp;
            <span style={{marginTop:"6px"}}>
         Page {currentPageB} Of {pageCountB} 
         
            </span>   &nbsp; &nbsp;
        {currentPageB<pageCountB?<li className="page-item">
              <a class="tecpage-link" onClick={onNextB} aria-label="Next">
                <span aria-hidden="true">&raquo;</span>
                <span class="sr-only">Next</span>
              </a>
            </li>:null}
    </ul>
  </nav>}
</div>

)}



   

    </div>
    </div>

    

    {pop? <div id="Loader">
<Oval
  height={40}
  width={50}
  id="Loader"
  color="black"
  wrapperStyle={{}}
  wrapperClass=""
  visible={true}
  ariaLabel='oval-loading'
  secondaryColor="gray"
  strokeWidth={2}
  strokeWidthSecondary={2}

/>
     </div>
 :null}
<div id="TecDenied">
   <span id="TecActionDeniedA"></span>

   </div>
    </div>

    </>
  
  )
}

export default TecAboutMain
